import React from 'react';

interface OverviewTabProps {
    selectedTeam: any;
    isDark: boolean;
    formatDate: (dateString: string) => string;
}

const OverviewTab: React.FC<OverviewTabProps> = ({ selectedTeam, isDark, formatDate }) => (
    <div className="space-y-6">
        <div className="text-center mb-8">
            <h3 className="text-3xl font-bold cgm-text-primary mb-2">{selectedTeam.name}</h3>
            <p className="text-lg cgm-text-secondary">{selectedTeam.organization.name}</p>
            <p className="text-sm cgm-text-secondary mt-2">Created on {formatDate(selectedTeam.created_at)}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className={`bg-gradient-to-br ${isDark ? 'from-blue-900/20 to-blue-800/20' : 'from-blue-50 to-blue-100'} rounded-2xl p-6 text-center border ${isDark ? 'border-blue-700/50' : 'border-blue-200/50'}`}>
                <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center text-white text-2xl mx-auto mb-4">
                    👨‍💼
                </div>
                <div className="text-3xl font-bold cgm-text-primary mb-2">{selectedTeam.coaches.length}</div>
                <div className="text-sm cgm-text-primary font-medium">Coaches</div>
            </div>
            <div className={`bg-gradient-to-br ${isDark ? 'from-emerald-900/20 to-emerald-800/20' : 'from-emerald-50 to-emerald-100'} rounded-2xl p-6 text-center border ${isDark ? 'border-emerald-700/50' : 'border-emerald-200/50'}`}>
                <div className="w-16 h-16 bg-gradient-to-r from-emerald-500 to-emerald-600 rounded-2xl flex items-center justify-center text-white text-2xl mx-auto mb-4">
                    🏃‍♂️
                </div>
                <div className="text-3xl font-bold cgm-text-primary mb-2">{selectedTeam.athletes.length}</div>
                <div className="text-sm cgm-text-primary font-medium">Athletes</div>
            </div>
            <div className={`bg-gradient-to-br ${isDark ? 'from-purple-900/20 to-purple-800/20' : 'from-purple-50 to-purple-100'} rounded-2xl p-6 text-center border ${isDark ? 'border-purple-700/50' : 'border-purple-200/50'}`}>
                <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-purple-600 rounded-2xl flex items-center justify-center text-white text-2xl mx-auto mb-4">
                    📱
                </div>
                <div className="text-3xl font-bold cgm-text-primary mb-2">{selectedTeam.athletes.filter((athlete: any) => athlete.whoop_connected).length}</div>
                <div className="text-sm cgm-text-primary font-medium">Connected to Whoop</div>
            </div>
        </div>
        {selectedTeam.description && (
            <div className={`bg-gradient-to-br ${isDark ? 'from-gray-700/50 to-gray-600/50' : 'from-gray-50 to-gray-100'} rounded-2xl p-6 border ${isDark ? 'border-gray-600/50' : 'border-gray-200/50'}`}>
                <h4 className="text-lg font-semibold cgm-text-primary mb-3">Team Description</h4>
                <p className="cgm-text-secondary leading-relaxed">{selectedTeam.description}</p>
            </div>
        )}
    </div>
);

export default OverviewTab; 